import { useStore } from 'vuex'

type ApiCall = {
  endpoint?: string

  action?: string
  actionAfter?: string
  actionAfterArgs?: Object
  actionArgs?: string
  apiVersion?: string
  cacheCancelIdPart?: string
  callId?: string
  canceledLoadingValue?: boolean
  clearCacheOnError?: boolean
  continueAfterCancel?: boolean
  customHeaders?: Object
  dissIfSameCallInProgress?: boolean
  fn?: Function
  gwCacheAdd?: boolean
  gwCacheId?: string
  gwCacheInvalidate?: boolean
  gwCacheSkipOnError?: boolean
  hasAuth?: boolean
  ignoreNeedToRefresh?: boolean
  isUpload?: boolean
  mergeData?: boolean
  message?: Object
  method?: 'get' | 'patch' | 'post' | 'patch' | 'delete' | 'put'
  mutation?: string
  mutationArgs?: Object
  replace?: boolean
  times?: number
  waitForCache?: boolean
  hasCancel?: boolean
}

interface CallT {
  loaded?: boolean
  loading?: boolean
  error?: object
  canceled?: boolean
  status?: number
  result?: any // TODO
  resultData?: any // TODO
  conf: ApiCall | {}
  data?: object
  params?: object
}

export const useFetch = () => {
  const store = useStore()

  const fetch = async (call: CallT) => {
    call.loaded = false
    call.loading = true
    call.result = undefined
    call.error = undefined

    const result = await store.dispatch('api_call', {
      ...call.conf,
      params: call.params,
      data: call.data,
    })

    call.data = undefined
    call.params = undefined

    call.result = result
    call.loading = false
    call.loaded = true

    call.status = result?.status

    const error = !result || result.error || !result.response

    call.error = error
    call.canceled = !!error?.canceled

    const data = result?.response?.data
    call.resultData = data

    return { call, data, error }
  }

  return { fetch }
}

export const getFetchCallBase = (conf: ApiCall) => ({
  loaded: false,
  loading: false,
  error: undefined,
  canceled: false,
  status: 0,
  params: {},
  data: {},
  result: undefined,
  resultData: undefined,
  conf,
})
